var _desc, _defs, _rect, _rect2, _rect3, _line, _line2, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncoisFuturex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 560",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "INCOIS Marine Fisheries Platform thumbnail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Marine fisheries dashboard with a recognizable India map, coastal PFZ points, and INCOIS map controls.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ocean",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#071426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopColor: "#111c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#263943"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#102039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1d2b40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0b74de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coral",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff8a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff5f3d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-70%",
    y: "-70%",
    width: "240%",
    height: "240%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "mapShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 10,
    floodColor: "#020617",
    floodOpacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "url(#ocean)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 68,
    fill: "#101827"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68,
    width: 190,
    height: 492,
    fill: "#0f172a"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 68,
    x2: 190,
    y2: 560,
    stroke: "#243247"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 68,
    x2: 900,
    y2: 68,
    stroke: "#243247"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 42,
    height: 42,
    rx: 11,
    fill: "url(#blue)",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 30c8 4 16 4 24 0M29 39c8 4 16 4 24 0M29 48c8 4 16 4 24 0",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 36,
    fill: "#ffffff",
    fontSize: 21,
    fontWeight: 900
  }, "INCOIS"), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 55,
    fill: "#99a7ba",
    fontSize: 13
  }, "Marine Fisheries"), /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 41,
    fill: "#9aa8bd",
    fontSize: 15,
    fontWeight: 700
  }, "Dashboard"), /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 41,
    fill: "#9aa8bd",
    fontSize: 15,
    fontWeight: 700
  }, "Advisories"), /*#__PURE__*/React.createElement("rect", {
    x: 554,
    y: 20,
    width: 64,
    height: 38,
    rx: 11,
    fill: "url(#coral)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 578,
    y: 44,
    fill: "#ffffff",
    fontSize: 16,
    fontWeight: 900
  }, "Map"), /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 41,
    fill: "#9aa8bd",
    fontSize: 15,
    fontWeight: 700
  }, "Alerts"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 118,
    fill: "#ffffff",
    fontSize: 22,
    fontWeight: 900
  }, "PFZ Zones"), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 142,
    width: 150,
    height: 38,
    rx: 8,
    fill: "#101a2c",
    stroke: "#33425b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 167,
    fill: "#ffffff",
    fontSize: 15
  }, "All Sectors"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 210,
    width: 150,
    height: 76,
    rx: 13,
    fill: "#1e2d43",
    stroke: "#3a4b64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 226,
    width: 79,
    height: 25,
    rx: 8,
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 244,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900
  }, "KERALA"), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 272,
    fill: "#a9bbd2",
    fontSize: 13
  }, "SST: 28.5 C")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 306,
    width: 150,
    height: 76,
    rx: 13,
    fill: "#1e2d43",
    stroke: "#3a4b64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 322,
    width: 94,
    height: 25,
    rx: 8,
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 340,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900
  }, "TAMIL NADU"), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 368,
    fill: "#a9bbd2",
    fontSize: 13
  }, "SST: 29.2 C")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 402,
    width: 150,
    height: 76,
    rx: 13,
    fill: "#1e2d43",
    stroke: "#3a4b64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 418,
    width: 82,
    height: 25,
    rx: 8,
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 436,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900
  }, "GUJARAT"), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 464,
    fill: "#a9bbd2",
    fontSize: 13
  }, "SST: 27.5 C")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    stroke: "#8aa0b7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 112h642M220 170h642M220 228h642M220 286h642M220 344h642M220 402h642M220 460h642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 88v430M330 88v430M410 88v430M490 88v430M570 88v430M650 88v430M730 88v430M810 88v430"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "#aab6c5",
    fontSize: 13,
    fontWeight: 700,
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 122
  }, "PAKISTAN"), /*#__PURE__*/React.createElement("text", {
    x: 526,
    y: 115
  }, "NEPAL"), /*#__PURE__*/React.createElement("text", {
    x: 626,
    y: 132
  }, "BHUTAN"), /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 208
  }, "BANGLADESH"), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 352
  }, "ARABIAN SEA"), /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 374
  }, "BAY OF BENGAL"), /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 497
  }, "SRI LANKA"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "india-map",
    filter: "url(#mapShadow)",
    fill: "#070b10",
    stroke: "#263746",
    strokeWidth: 1.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392,188L407,197L414,211L417,210L424,212L427,214L430,223L432,226L436,227L421,237L428,245L425,252L421,257L413,262L411,261L412,253L407,249L402,251L402,255L400,267L393,269L385,259L375,254L364,253L350,229L373,208L392,187L392,188Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,226L445,237L437,255L441,246L444,246L450,245L459,248L465,249L473,247L485,258L474,266L469,279L463,292L455,290L434,292L416,296L402,289L399,289L396,286L395,279L400,267L403,252L406,252L411,263L423,256L426,245L437,226L439,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,285L437,290L457,325L399,351L389,360L387,355L386,353L386,351L386,349L385,346L385,344L384,341L384,337L383,335L382,333L383,331L383,330L381,328L382,324L382,322L381,322L380,320L380,319L380,315L379,311L387,301L397,285L398,285Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,183L432,190L443,196L451,202L461,205L475,213L488,219L498,225L499,233L496,243L493,252L485,254L473,248L468,249L462,247L458,244L449,245L445,245L442,244L445,255L439,247L445,236L444,227L430,227L428,217L427,202L431,183L431,183Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,253L380,305L380,295L379,291L377,289L381,282L376,280L375,286L375,288L373,294L369,297L360,300L353,297L349,292L347,290L342,285L341,280L346,280L350,279L354,276L353,273L348,276L340,273L337,270L335,267L338,262L372,253L373,253Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,328L427,353L426,378L431,386L434,397L418,410L402,398L402,396L401,394L401,391L401,391L400,387L399,384L399,383L398,382L398,380L397,377L397,376L397,376L396,375L396,374L395,374L394,373L394,372L398,358L409,346L427,329L428,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,349L478,352L473,354L469,355L467,360L465,361L460,361L458,365L457,372L458,376L458,383L459,389L457,387L457,389L438,396L455,350L503,322L504,324L502,327L499,330L495,333L492,336L490,339L485,341L481,344L480,347L480,349L480,349Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,279L534,290L530,291L528,294L528,297L528,300L527,301L530,301L527,303L527,305L525,307L524,308L524,308L522,309L523,310L519,311L515,313L511,315L508,318L507,319L506,320L505,320L491,321L480,333L481,311L495,282L520,278L520,279Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,259L498,267L502,274L496,281L493,290L487,295L481,301L484,310L477,309L479,317L476,326L471,335L465,331L459,326L463,318L461,311L462,303L461,296L463,292L464,288L466,284L471,279L477,272L476,267L473,262L482,263L490,260L491,259Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,388L459,392L459,396L458,400L456,402L456,404L455,406L454,413L454,417L454,428L452,428L451,427L449,428L448,431L446,434L445,438L446,440L442,442L438,443L437,446L436,448L436,449L434,452L430,454L427,453L421,420L456,388L457,388Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,121L436,125L442,132L443,138L446,147L450,152L448,157L443,156L439,157L436,155L434,153L431,152L427,152L423,150L422,149L417,150L412,153L409,159L405,157L400,155L397,151L394,144L392,137L398,129L409,132L419,129L429,124L434,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,359L429,354L429,350L430,346L430,341L429,339L431,334L430,329L433,324L434,319L438,316L440,312L446,315L452,315L455,322L460,327L464,329L465,332L470,336L473,337L467,343L462,344L462,348L457,346L448,353L440,357L432,360L430,359Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,218L505,220L506,224L509,225L512,227L517,229L522,229L527,231L533,232L539,231L542,230L540,235L540,240L538,243L532,247L530,253L523,256L515,252L507,255L499,255L491,250L494,244L502,240L499,233L501,229L498,222L499,218L499,218Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626,195L627,200L629,204L632,207L638,210L636,215L635,221L632,220L624,222L618,227L616,225L618,221L624,219L622,216L612,215L606,217L601,222L593,225L583,224L580,218L578,214L587,214L594,208L601,204L608,197L616,198L623,195L626,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,223L557,234L550,232L545,231L544,240L543,249L548,268L549,276L550,278L548,279L549,280L547,282L546,284L546,285L545,287L545,286L544,286L543,287L542,288L541,282L539,280L542,283L540,286L537,289L519,271L539,253L541,222L541,223Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623,213L624,219L616,224L608,228L603,234L599,239L597,244L595,250L593,255L589,257L584,255L586,250L588,247L589,241L584,237L579,236L573,239L567,237L560,240L560,237L559,236L558,234L560,228L574,226L592,225L605,218L619,213L623,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,245L538,251L538,254L537,257L535,260L532,261L529,262L523,267L518,267L522,273L525,277L527,282L520,278L518,285L511,285L507,280L500,277L499,270L493,262L496,254L502,256L510,255L516,251L523,255L529,254L531,250L536,244L536,245Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,148L426,151L430,152L434,153L437,155L440,158L440,160L442,162L443,165L443,167L443,170L444,172L443,173L437,173L433,175L433,177L433,179L431,182L428,182L425,178L421,176L419,172L415,169L411,163L413,155L417,150L422,148L422,148Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,171L450,174L452,176L456,177L458,178L459,181L463,182L466,185L462,188L460,191L459,194L459,197L455,202L452,201L449,200L444,198L444,195L435,193L434,191L433,186L433,184L430,183L432,179L433,176L438,172L445,173L447,171L448,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,157L413,165L416,171L420,173L422,178L423,181L422,183L420,187L417,186L417,186L416,188L412,190L406,193L404,189L395,188L392,183L394,180L396,178L399,174L399,174L398,173L399,169L400,165L402,163L405,162L407,160L412,157L413,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,177L426,181L431,183L426,189L426,196L424,202L427,206L430,211L427,214L425,215L424,212L420,212L417,210L416,213L414,211L411,206L407,197L399,195L400,188L406,190L410,190L416,189L416,186L418,186L421,185L424,183L423,176L423,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,397L426,452L423,449L421,446L419,442L419,441L417,436L417,433L417,433L418,437L418,435L417,433L417,430L416,430L416,431L415,427L414,425L413,419L412,417L410,412L409,410L407,408L407,407L406,407L405,405L404,401L403,397L403,397Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,235L584,235L584,238L586,239L589,242L590,244L588,247L586,247L583,247L581,246L579,247L577,247L575,246L572,246L569,246L568,246L566,246L563,246L560,245L559,243L560,239L563,237L568,237L571,238L574,239L577,237L580,235L580,235Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,241L610,243L610,246L610,249L609,252L608,254L606,258L605,261L603,261L600,261L598,261L596,259L594,260L592,259L593,255L594,253L594,251L595,250L595,249L595,248L596,247L597,245L599,245L601,242L603,241L606,242L609,240L609,241Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590,256L593,257L595,260L597,264L596,269L594,272L594,277L595,281L593,284L591,284L588,285L588,283L588,279L587,276L587,275L586,274L586,272L586,270L586,269L586,267L585,266L585,264L585,261L585,259L587,259L589,257L590,255L590,256Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616,225L616,227L615,230L615,232L615,235L614,237L613,240L612,242L609,242L608,241L605,242L602,242L600,244L598,245L596,242L597,241L598,239L600,238L601,238L603,236L603,234L605,231L607,230L608,228L610,227L612,225L616,224L616,225Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,254L585,258L585,262L585,264L583,264L581,264L582,267L580,268L580,270L580,272L579,273L578,273L577,273L577,271L576,270L576,271L575,270L574,268L573,266L574,264L574,261L576,259L578,259L580,259L581,259L582,256L584,254L584,254Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,211L548,211L549,213L549,214L549,215L549,216L548,218L548,219L549,219L549,220L549,221L548,222L547,222L545,222L543,222L541,222L541,220L541,219L541,217L542,215L542,214L541,213L542,212L543,212L544,212L546,211L546,210L547,211Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "#d6dee8",
    fontSize: 15,
    fontWeight: 900
  }, /*#__PURE__*/React.createElement("text", {
    x: 493,
    y: 236
  }, "INDIA"), /*#__PURE__*/React.createElement("text", {
    x: 421,
    y: 397
  }, "KERALA"), /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 430
  }, "TAMIL NADU"), /*#__PURE__*/React.createElement("text", {
    x: 367,
    y: 194
  }, "GUJARAT"), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 332
  }, "ODISHA"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 203,
    r: 8,
    fill: "#0ea5e9",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 390,
    r: 8,
    fill: "#0ea5e9",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 437,
    r: 8,
    fill: "#0ea5e9",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566,
    cy: 360,
    r: 8,
    fill: "#0ea5e9",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 300,
    r: 8,
    fill: "#0ea5e9",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 236,
    r: 8,
    fill: "#0ea5e9",
    stroke: "#ffffff",
    strokeWidth: 3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 88,
    width: 126,
    height: 86,
    rx: 14,
    fill: "url(#panel)",
    stroke: "#3a4b64"
  }), /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 119,
    fill: "#ffffff",
    fontSize: 17,
    fontWeight: 900
  }, "Layers"), /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 150,
    fill: "#dce6f2",
    fontSize: 13,
    fontWeight: 800
  }, "PFZ Zones"), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 136,
    width: 34,
    height: 18,
    rx: 9,
    fill: "#0b74de"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 190,
    width: 126,
    height: 100,
    rx: 14,
    fill: "url(#panel)",
    stroke: "#3a4b64"
  }), /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 222,
    fill: "#ffffff",
    fontSize: 17,
    fontWeight: 900
  }, "3D View"), /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 255,
    fill: "#dce6f2",
    fontSize: 13,
    fontWeight: 800
  }, "Enable 3D"), /*#__PURE__*/React.createElement("circle", {
    cx: 277,
    cy: 274,
    r: 8,
    fill: "#0b74de"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 90,
    width: 114,
    height: 112,
    rx: 14,
    fill: "url(#panel)",
    stroke: "#3a4b64"
  }), /*#__PURE__*/React.createElement("text", {
    x: 778,
    y: 119,
    fill: "#aebbd0",
    fontSize: 13,
    fontWeight: 900
  }, "Quick Nav"), /*#__PURE__*/React.createElement("text", {
    x: 778,
    y: 150,
    fill: "#ffffff",
    fontSize: 14,
    fontWeight: 900
  }, "GUJ"), /*#__PURE__*/React.createElement("text", {
    x: 828,
    y: 150,
    fill: "#ffffff",
    fontSize: 14,
    fontWeight: 900
  }, "MAH"), /*#__PURE__*/React.createElement("text", {
    x: 778,
    y: 185,
    fill: "#ffffff",
    fontSize: 14,
    fontWeight: 900
  }, "KER"), /*#__PURE__*/React.createElement("text", {
    x: 828,
    y: 185,
    fill: "#ffffff",
    fontSize: 14,
    fontWeight: 900
  }, "TAM"), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 490,
    width: 662,
    height: 36,
    rx: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 225,
    y: 513,
    fill: "#111827",
    fontSize: 13
  }, "MapLibre | CARTO | OpenStreetMap contributors"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncoisFuturex);
export default __webpack_public_path__ + "static/media/incois-futurex.a8f50d1dd20a4fbc16cd755e93add1e0.svg";
export { ForwardRef as ReactComponent };